/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_SignInputs */

const en_pc_cmp_r_sign = /** @type {(inputs: Pc_Cmp_R_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signatures`)
};

const zh_pc_cmp_r_sign = /** @type {(inputs: Pc_Cmp_R_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`签名`)
};

/**
* | output |
* | --- |
* | "Signatures" |
*
* @param {Pc_Cmp_R_SignInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_sign = /** @type {((inputs?: Pc_Cmp_R_SignInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_SignInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_sign(inputs)
	return zh_pc_cmp_r_sign(inputs)
});
export { pc_cmp_r_sign as "pc.cmp.r.sign" }